// import 'svgxuse'; // Uncomment to support svg icons on IE
// import add, { selectSomething } from './components/example';

// bower_components/aos/dist/aos.js
// import 'aos';

import AOS from "aos";

AOS.init();

import "./components/faqs-slider";
import "./components/fullscreen-menu-modal";
import "./components/image-slider";

// console.log( add( 1, 2 ) );
// console.log( selectSomething() );
